const HouseIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    className={className}
  >
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M6.75 16.5v-6h4.5v6m-9-9.75L9 1.5l6.75 5.25V15a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V6.75Z'
    />
  </svg>
);

export default HouseIcon;
